/* global yaCounter85761313 */
import vars from '../helpers';
import scrollDepth from 'scroll-depth';

function start15SecTimeout() {
	clearTimeout(vars.$window.data('timeout15Sec'));

	vars.$window.data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

start15SecTimeout();

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	},
});

$('.js-header-rbc').on('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

$('.js-header-partner').on('click', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

// Ссылок нет. Нужна ссылка на сайт клиента
$('.intro a, .lead a, .section a').on('click', (e) => {
	let link = $(e.currentTarget).attr('href');
	let name = $(e.currentTarget).text();

	if (link.indexOf('bork.ru') > 0) {
		ga('send', 'event', 'client link', 'article text link', name);
		ga('rbcspec.send', 'event', 'client link', 'click');
	} else {
		ga('send', 'event', 'article', 'article text link', name);
	}
});

$('.share__button').on('click', (e) => {
	const name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'project share', name);
});

vars.$html
	.on('video-play', (e, name) => {
		ga('send', 'event', 'video', 'play', name, {nonInteraction: true});
		ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});
	})
	.on('video-ended', (e, name) => {
		ga('send', 'event', 'video', 'finish', name);
		ga('rbcspec.send', 'event', 'video', 'finish');
	})
	.on('video-interval-30', (e, name) => {
		ga('send', 'event', 'video', 'timing 30s', name, 30);
		ga('rbcspec.send', 'event', 'video', 'timing 30s', '', 30);
	})
	.on('scroll-button-click', (e, name) => {
		ga('send', 'event', 'article', 'progress menu click', name);
	})
	.on('scroll-arrow-button-click', (e, type) => {
		ga('send', 'event', 'article', 'progress arrow', type);
	})
;

/**
* Создать куки запись
* @param {string} path Обязательное, ссылка/путь
*/
function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		// Не всегда используются
		// ga('rbcspec.set', 'page', path);
		// ga('rbcspec.send', 'pageview', path);
	}

	if (window.yaCounter85761313) {
		yaCounter85761313.hit(path);
	}
}

export default {
	start15SecTimeout,
	virtualHit,
};
